import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const API_URL = "/api";

export interface TelegramLinkStatus {
  linked: boolean;
  chatId?: string;
}

export function useTelegramLink() {
  return useQuery({
    queryKey: ["telegram-link"],
    queryFn: async (): Promise<TelegramLinkStatus> => {
      const res = await fetch(`${API_URL}/me/telegram-link`, { credentials: "include" });
      if (!res.ok) throw new Error(`${res.status}`);
      const body = await res.json();
      return (body.data ?? body) as TelegramLinkStatus;
    },
  });
}

export function useUnlinkTelegram() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await fetch(`${API_URL}/me/telegram-link`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!res.ok) throw new Error(`${res.status}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["telegram-link"] });
      toast.success("Telegram disconnected");
    },
    onError: () => toast.error("Failed to disconnect Telegram"),
  });
}
